export default "__VITE_ASSET__BwiGEP5x__"